<template>
  <div>
    <Modal v-model="visible" title="选择活动" width="90%" class="my-modal" :mask-closable="false" :footer-hide="true">
      <div class="search-box btn3">
        <div class="input-item">
          <span class="label">活动名称</span>
          <Input v-model="searchParams.name" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">活动类型</span>
          <Select v-model="searchParams.type" transfer placeholder="请选择" clearable>
            <Option value="1">增员活动</Option>
            <Option value="2">出单活动</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">活动方式</span>
          <Select v-model="searchParams.mode" transfer placeholder="请选择" clearable>
            <Option value="1">无门槛</Option>
            <Option value="2">梯度</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">活动状态</span>
          <Select v-model="searchParams.status" filterable clearable>
            <Option value="0">未开始</Option>
            <Option value="1">进行中</Option>
            <Option value="-1">已结束</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">开始时间</span>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            v-model="searchParams.startTime"
            placeholder="选择日期"
          ></DatePicker>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="status">
            <div class="tag">
              <span v-if="row.status == '0'" class="item not-started">未开始</span>
              <span v-else-if="row.status == '1'" class="item in-progress">进行中</span>
              <span v-else-if="row.status == '-1'" class="item ended">已结束</span>
            </div>
          </template>

          <template slot-scope="{ row }" slot="org">
            <div class="detail">
              <div @click="$refs.treeModal.open(row, true)">{{ row.isAllotOrg || row.calculateType == '1' ? '查看' : '配置' }}</div>
            </div>
          </template>
          <template slot-scope="{ row }" slot="salesman">
            <span class="table-btn" @click="$refs.okSalesman.open(row, true)">{{ row.isAllotOrg || row.calculateType == '1' ? '查看' : '配置' }}</span>
          </template>
          <template slot-scope="{ row }" slot="detail">
            <div class="detail">
              <div @click="row.type == 1 ? $refs.detailModal.open(row) : $refs.detailProductModal.open(row)">查看</div>
            </div>
          </template>
          <template slot-scope="{ row }" slot="action">
            <div class="detail">
              <div @click="confirmSelect(row)">选择</div>
            </div>
          </template>
        </Table>
        <div class="pageBox">
          <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
        </div>
      </div>
    </Modal>
    <detailModal ref="detailModal" />
    <treeModal ref="treeModal" />
    <detailProductModal ref="detailProductModal" />
    <okCheckSalesman ref="okSalesman" @success="searchAjax"></okCheckSalesman>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filters from '@/api/filter';
import treeModal from '@/pages/activityManage/recruiting/components/treeModal';
import detailModal from '@/pages/activityManage/recruiting/components/detailModal';
import detailProductModal from '@/pages/activityManage/recruiting/components/detailProductModal';
import okCheckSalesman from '@/pages/activityManage/recruiting/components/okCheckSalesman';
export default {
  mixins: [pageTool, common],
  components: {
    treeModal,
    detailModal,
    okCheckSalesman,
    detailProductModal
  },
  data() {
    return {
      visible: false,
      searchParams: {},
      columns: [
        {
          title: '活动ID',
          key: 'id',
          align: 'center',
          minWidth: 200
        },
        {
          title: '活动名称',
          key: 'name',
          align: 'center',
          width: '260'
        },
        {
          title: '活动类型',
          key: 'type',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            if (params.row.type) {
              return <span>{params.row.type == 1 ? '增员活动' : '出单活动'}</span>;
            }
          }
        },
        {
          title: '活动方式',
          key: 'mode',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            if (params.row.mode) {
              return <span>{params.row.mode == 1 ? '无门槛' : '梯度'}</span>;
            }
          }
        },
        {
          title: '活动状态',
          align: 'center',
          slot: 'status',
          minWidth: 100
        },
        {
          title: '开始时间',
          key: 'startTime',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            return <span>{filters.filterTime(params.row.startTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结束时间',
          key: 'endTime',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            return <span>{filters.filterTime(params.row.endTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '是否展示',
          key: 'showType',
          align: 'center',
          minWidth: 100,
          renderHeader: (h, params) => {
            return (
              <div>
                <span>是否展示</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                  <div slot="content">
                    <p>如果关闭展示，业务员将无法在展业端看到此活动</p>
                  </div>
                </Poptip>
              </div>
            );
          },
          render(h, params) {
            return <span>{params.row.showType == 1 ? '是' : '否'}</span>;
          }
        },
        {
          title: '参与组织',
          slot: 'org',
          key: 'orgSalesman',
          align: 'center',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '120',
          fixed: 'right'
        }
      ],
      userInfo: JSON.parse(localStorage.getItem('userInfo'))
    };
  },
  mounted() {
    if (this.userInfo.merchantNo == '260580000000800') {
      this.columns.map(item => {
        if (item.key == 'orgSalesman') {
          item.title = '参与业务员';
          item.slot = 'salesman';
        }
      });
    }
  },
  methods: {
    open() {
      this.initListAjax('/buz/merchantActivity/queryList');
    },
    // 选中产品
    confirmSelect(item) {
      this.$emit('confirm-select', item);
      this.visible = false;
    },
    setListParams(params) {
      if (params.startTime && params.startTime[0]) {
        params.startTimeStart = filters.filterTime(params.startTime[0], 'YYYY-MM-DD');
        params.startTimeEnd = filters.filterTime(params.startTime[1], 'YYYY-MM-DD');
      }
      delete params.startTime;
    },
    listCallback(resData) {
      sessionStorage.setItem('isSupportRegisterSalesman', resData.data.isSupportRegisterSalesman);
      sessionStorage.setItem('isSupportFirstPolicy', resData.data.isSupportFirstPolicy);
      resData.total = resData.data.data.total;
      resData.data = resData.data.data.records;
      if(!this.visible) {
        if(resData.total == 0) {
          this.$notice.error('活动管理内没有活动可供选择！')
        }else{
          this.visible = true;
        }
      }
    },
    changeShowType(value, row) {
      this.$http({
        url: '/buz/merchantActivity/showActivity',
        type: 'POST',
        data: {
          id: row.id,
          showType: value
        }
      }).then(res => {});
    }
  }
};
</script>

<style>
</style>